import React from "react";

const HamburgerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 5h18v1H3zm0 8h18v-1H3zm0 7h18v-1H3z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
  );
};

export default HamburgerIcon;
